import { PromptSidebarContent } from "@rapid/components/flow/build/Steps/Prompt/SidebarContent/PromptSidebarContent";
import { ReviewSidebarContent } from "@rapid/components/flow/build/Steps/Review/SidebarContent";
import { ReviewContextProvider } from "@rapid/components/flow/build/Steps/Review/ReviewContext";
import { PromptVisualAreaContent } from "@rapid/components/flow/build/Steps/Prompt/VisualAreaContent";
import { ReviewVisualAreaContent } from "@rapid/components/flow/build/Steps/Review/VisualAreaContent";
import { ReviewGridViewProvider } from "@rapid/contexts/ReviewGridViewContext";
import { UploadVisualAreaContent } from "@rapid/components/flow/build/Steps/Upload/VisualAreaContent";
import { PromptVisualAreaBottomContent } from "@rapid/components/flow/build/Steps/Prompt/VisualAreaBottomContent";
import { PreviewSidebarContent } from "@rapid/components/flow/build/Steps/Preview/SidebarContent";
import { PreviewVisualAreaContent } from "@rapid/components/flow/build/Steps/Preview/VisualAreaContent";
import { BuildLayout } from "@rapid/components/flow/build/Layout";
import { BuildSteps } from "@rapid/types/flows";
import { useFlowState } from "@rapid/hooks/useFlowState";

export const BuildPage = () => {
    const { step } = useFlowState();

    switch (step) {
        case BuildSteps.UPLOAD:
            return <UploadVisualAreaContent />;
        case BuildSteps.PROMPT:
            return (
                <BuildLayout
                    Sidebar={<PromptSidebarContent />}
                    VisualArea={<PromptVisualAreaContent />}
                    BottomContent={<PromptVisualAreaBottomContent />}
                />
            );
        case BuildSteps.REVIEW:
            return (
                <ReviewGridViewProvider>
                    <ReviewContextProvider>
                        <BuildLayout
                            Sidebar={<ReviewSidebarContent />}
                            VisualArea={<ReviewVisualAreaContent />}
                        />
                    </ReviewContextProvider>
                </ReviewGridViewProvider>
            );
        case BuildSteps.PREVIEW:
            return (
                <BuildLayout
                    Sidebar={<PreviewSidebarContent />}
                    VisualArea={<PreviewVisualAreaContent />}
                    // BottomContent={<PreviewVisualAreaBottomContent />}
                />
            );
        default:
            throw new Error(`Invalid step: ${step}`);
    }
};
